import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = "Page not found - Ample Hire";
  }, []);

  const mailtoSubject = encodeURIComponent(`Broken link: ${pathname}`);
  const mailtoBody = encodeURIComponent(
    `I hit a broken link in Ample Hire.\n\nPath: ${pathname}\n\nWhat I was trying to do:\n`
  );

  return (
    <div className="page-enter">
      <div className="bg-white border border-slate-200 rounded-xl py-16 px-6 text-center max-w-2xl mx-auto mt-8">
        <div className="text-5xl mb-4">404</div>
        <h1 className="text-2xl font-semibold text-vf-base mb-2">
          Page not found
        </h1>
        <p className="text-sm text-vf-muted max-w-md mx-auto mb-2">
          We couldn't find anything at this address.
        </p>
        <p className="text-xs text-vf-muted max-w-md mx-auto mb-6 font-mono break-all">
          {pathname}
        </p>
        <div className="flex items-center justify-center gap-3">
          <Link
            to="/admin/dashboard-v2"
            className="px-3 py-1.5 rounded bg-vf-primary text-white text-xs font-medium"
          >
            Back to dashboard
          </Link>
          <a
            href={`mailto:support@amplehire.com?subject=${mailtoSubject}&body=${mailtoBody}`}
            className="px-3 py-1.5 rounded border border-slate-200 text-xs text-vf-primary hover:bg-vf-tint/30"
          >
            Report broken link
          </a>
        </div>
      </div>
    </div>
  );
}
